import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Box, Group, Drawer, Input, Text, ActionIcon } from '@mantine/core';
import { IconTrash, IconPlus, IconPencil, IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_ONE, utils } from "../../utils/globalVariables";
// import { safeValue, removeFromArrayByIndex, changeValueOfArrayImmutable, isEmptyArrayObject } from "../../utils/globalFunctions";

import InputComponent from "../../components/general/InputComponent";
import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";

const BarangFormCekEditDetil = ({ stateShow, fnShow, stateData, fnSuccessAdd, fnSuccessDelete, fnSuccessEdit }) => {

    const mountedRef = React.useRef(true);
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorTambahData: 'BarangFormCekEditDetil-1',
        successTambahData: 'BarangFormCekEditDetil-2',

        errorEditData: 'BarangFormCekEditDetil-3',
        successEditData: 'BarangFormCekEditDetil-4',

        errorDeleteData: 'BarangFormCekEditDetil-5',
        successDeleteData: 'BarangFormCekEditDetil-6',
    })

    const constBarangFormCekDetil = {
        id: 'editBarangFormCekDetil',
        label: 'List Item',
        withAsterisk: false,
        placeholder: 'List Item',
        value: [],
        description: '',
        error: ''
    }

    const [data, setData] = React.useState({
        barangFormCekDetil: constBarangFormCekDetil,
        barangFormCekId: '',

        tambahModal: false,
        tambahInput: '',
        tambahInputError: '',
        tambahLoading: false,

        editModal: false,
        editId: '',
        editInput: '',
        editInputError: '',
        editLoading: false,

        deleteModal: false,
        deleteId: '',
        deleteName: '',
        deleteLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        setData(d => ({
            ...d,
            barangFormCekDetil: {
                ...d.barangFormCekDetil,
                value: Array.isArray(stateData.barang_form_cek_detil) ? stateData.barang_form_cek_detil : [],
                error: '',
            },
            barangFormCekId: stateData.barang_form_cek_id
        }))
    }, [stateData])

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const tambahData = () => {
        setData(d => ({ ...d, tambahInputError: '' }));

        if (validator.isEmpty(data.tambahInput, { ignore_whitespace: true })) {
            setData(d => ({ ...d, tambahInputError: 'Item wajib diisi!' }));
        } else {
            setData(d => ({ ...d, tambahLoading: true }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('item_name', data.tambahInput);
            formDT.append('master_id', data.barangFormCekId);

            axios({
                method: 'post',
                url: BE_API_ONE + '/form_cek_detil_tambah',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, tambahLoading: false }));

                if (response.data.flag_status === 'isset') {

                    setData(d => ({
                        ...d,
                        tambahInput: '',
                        tambahModal: false,

                        barangFormCekDetil: {
                            ...d.barangFormCekDetil,
                            value: response.data.data,
                        },
                    }));

                    fnSuccessAdd();

                    notifications.show({
                        id: notificationId.current.successTambahData,
                        title: utils.notification.success.caption,
                        message: 'Berhasil Tambah Data.',
                        color: utils.notification.success.color,
                        icon: utils.notification.success.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorTambahData,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, tambahLoading: false }));

                notifications.show({
                    id: notificationId.current.errorTambahData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: false,
                })
            })
        }
    }

    const editData = () => {
        setData(d => ({ ...d, editInputError: '' }));

        if (validator.isEmpty(data.editInput, { ignore_whitespace: true })) {
            setData(d => ({ ...d, editInputError: 'Item wajib diisi!' }));
        } else {
            setData(d => ({ ...d, editLoading: true }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('item_name', data.editInput);
            formDT.append('master_id', data.barangFormCekId);
            formDT.append('detil_id', data.editId);

            axios({
                method: 'post',
                url: BE_API_ONE + '/form_cek_detil_edit',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, editLoading: false }));

                if (response.data.flag_status === 'isset') {

                    setData(d => ({
                        ...d,
                        editInput: '',
                        editId: '',
                        editModal: false,

                        barangFormCekDetil: {
                            ...d.barangFormCekDetil,
                            value: response.data.data,
                        },
                    }));

                    fnSuccessEdit();

                    notifications.show({
                        id: notificationId.current.successEditData,
                        title: utils.notification.success.caption,
                        message: 'Berhasil Edit Data.',
                        color: utils.notification.success.color,
                        icon: utils.notification.success.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorEditData,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, editLoading: false }));

                notifications.show({
                    id: notificationId.current.errorEditData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: false,
                })
            })
        }
    }

    const deleteData = () => {
        setData(d => ({ ...d, deleteLoading: true }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('master_id', data.barangFormCekId);
        formDT.append('detil_id', data.deleteId);

        axios({
            method: 'post',
            url: BE_API_ONE + '/form_cek_detil_delete',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, deleteLoading: false }));

            if (response.data.flag_status === 'isset') {

                setData(d => ({
                    ...d,
                    deleteId: '',
                    deleteModal: false,

                    barangFormCekDetil: {
                        ...d.barangFormCekDetil,
                        value: response.data.data,
                    },
                }));

                fnSuccessDelete();

                notifications.show({
                    id: notificationId.current.successDeleteData,
                    title: utils.notification.success.caption,
                    message: 'Berhasil Delete Data.',
                    color: utils.notification.success.color,
                    icon: utils.notification.success.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorDeleteData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, deleteLoading: false }));

            notifications.show({
                id: notificationId.current.errorDeleteData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: false,
            })
        })
    }

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Edit Detil Form Cek</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Box py='md'>

                    <Box mb='2rem'>
                        <Input.Wrapper
                            id={data.barangFormCekDetil.id}
                            withAsterisk={data.barangFormCekDetil.withAsterisk}
                            label={
                                <Group noWrap position="apart">
                                    <Text>{data.barangFormCekDetil.label}</Text>

                                    <ActionIcon
                                        size='md'
                                        variant="light"
                                        radius='xl'
                                        color="blue"

                                        onClick={() => {
                                            setData(d => ({ ...d, tambahModal: true }));
                                        }}
                                    >
                                        <IconPlus size='1rem' />
                                    </ActionIcon>
                                </Group>
                            }
                            description={data.barangFormCekDetil.description}

                            styles={{
                                label: {
                                    width: '100%'
                                }
                            }}
                        >
                            {Object.keys(data.barangFormCekDetil.value).map((key, index) => {
                                return (
                                    <Group
                                        key={key}
                                        spacing='xs'
                                        noWrap
                                        position="apart"

                                        mt='xs'
                                        mb='xs'
                                        pb='xs'

                                        sx={(tema) => ({
                                            borderBottomWidth: (Number(index) + 1) === data.barangFormCekDetil.value.length ? '0px' : '1px',
                                            borderBottomStyle: 'solid',
                                            borderBottomColor: tema.colorScheme === 'light' ? tema.colors.gray[5] : tema.colors.dark[5]
                                        })}
                                    >
                                        <Group spacing='xs' noWrap>
                                            <Text size='sm'>
                                                {Number(index) + 1}.
                                            </Text>

                                            <Text size='sm'>
                                                {data.barangFormCekDetil.value[key].barang_form_cek_detil_name}
                                            </Text>
                                        </Group>

                                        <Group noWrap spacing='xs'>
                                            <ActionIcon
                                                size='md'
                                                variant="light"
                                                radius='xl'

                                                sx={(tema) => ({
                                                    '&:hover': {
                                                        backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[1] : tema.colors.dark[5]
                                                    },
                                                })}

                                                onClick={() => {
                                                    setData(d => ({
                                                        ...d,
                                                        editId: data.barangFormCekDetil.value[key].barang_form_cek_detil_id,
                                                        editInput: data.barangFormCekDetil.value[key].barang_form_cek_detil_name,
                                                        editModal: true,
                                                    }))
                                                }}
                                            >
                                                <IconPencil size='1rem' />
                                            </ActionIcon>

                                            <ActionIcon
                                                size='md'
                                                variant="light"
                                                radius='xl'

                                                sx={(tema) => ({
                                                    '&:hover': {
                                                        backgroundColor: tema.colorScheme === 'light' ? tema.colors.gray[1] : tema.colors.dark[5]
                                                    },
                                                })}

                                                onClick={() => {
                                                    setData(d => ({
                                                        ...d,
                                                        deleteId: data.barangFormCekDetil.value[key].barang_form_cek_detil_id,
                                                        deleteName: data.barangFormCekDetil.value[key].barang_form_cek_detil_name,
                                                        deleteModal: true,
                                                    }))
                                                }}
                                            >
                                                <IconTrash size='1rem' />
                                            </ActionIcon>
                                        </Group>
                                    </Group>
                                )
                            })}
                        </Input.Wrapper>
                    </Box>
                </Box>
            </Drawer>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.tambahModal}
                fnHide={() => setData(d => ({ ...d, tambahModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Tambah Item').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="blue"
                stateButtonActionLoading={data.tambahLoading}
                fnButtonAction={tambahData}
            >
                <InputComponent
                    stateId='tambah-data-1'
                    stateWithAsterisk={false}
                    stateLabel='Item'
                    stateDescription=''
                    statePlaceHolder='Contoh: USB Kiri'
                    stateReadOnly={false}
                    stateError={data.tambahInputError}

                    stateValue={data.tambahInput}
                    fnOnChange={(e) => setData(d => ({ ...d, tambahInput: e.target.value }))}
                />
            </ModalTakeAction>

            <ModalTakeAction
                stateShow={data.editModal}
                fnHide={() => setData(d => ({ ...d, editModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Edit Item').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="blue"
                stateButtonActionLoading={data.editLoading}
                fnButtonAction={editData}
            >
                <InputComponent
                    stateId='edit-data-1'
                    stateWithAsterisk={false}
                    stateLabel='Item'
                    stateDescription=''
                    statePlaceHolder='Contoh: USB Kiri'
                    stateReadOnly={false}
                    stateError={data.editInputError}

                    stateValue={data.editInput}
                    fnOnChange={(e) => setData(d => ({ ...d, editInput: e.target.value }))}
                />
            </ModalTakeAction>

            <ModalTakeAction
                stateShow={data.deleteModal}
                fnHide={() => setData(d => ({ ...d, deleteModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Delete Item').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="red"
                stateButtonActionLoading={data.deleteLoading}
                fnButtonAction={deleteData}
            >
                <Text size='sm' color="dimmed">
                    Hapus item "{data.deleteName}" ?
                </Text>
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default React.memo(BarangFormCekEditDetil);